import { useCallback, useMemo, useState } from "react";
import { TimekeeperService } from "services/TimekeeperService";
import { AccrualCode } from 'repository/timekeeper/@types/AccrualCode';
import { GridInputRowSelectionModel, GridColDef } from '@mui/x-data-grid-pro';
import { useTranslation } from "react-i18next";

const timekeeperService = new TimekeeperService();

export const useAccrualsData = () => {
    const { t } = useTranslation();
    const [rows, setRows] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number } | null>(null);
    const [selectedAccrualCode, setSelectedAccrualCode] = useState<GridInputRowSelectionModel | undefined>([]);
    const [selected, setSelected] = useState<any>([]);

    const loadData = useCallback(async () => {
        setLoading(true);
        try {
            const data = await timekeeperService.accrual_code.getAll();
            setRows(data as AccrualCode[]);
        } catch (error) {
            console.error("Error loading accrual codes:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    const columns: GridColDef[] = useMemo(() => [
        { field: 'name', headerName: t("accruals.accrual_codes.table.columns.name"), flex: 1 },
        { field: 'abbreviation', headerName: t("accruals.accrual_codes.table.columns.abbreviation"), flex: 1, headerAlign: 'center', align: 'center' },
        { field: 'type_accrual', headerName: t("accruals.accrual_codes.table.columns.type_accrual"), flex: 1, headerAlign: 'center', align: 'center'},
        {
            field: 'hour_per_day',
            headerName: t("accruals.accrual_codes.table.columns.hours_per_days"),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            filterable: false,
        },
        {
            field: 'allow_manual_edits',
            headerName: t("accruals.accrual_codes.table.columns.allow_manual_edits"),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            type: 'singleSelect',
            valueOptions: [t('general.basic.yes'), t('general.basic.no')],
            valueGetter: (value: boolean | null) => (value ? t('general.basic.yes') : t('general.basic.no')),
            renderCell: (params: any) => (params.row?.allow_manual_edits ? t('general.basic.yes') : t('general.basic.no')),
        },
        {
            field: 'show_code',
            headerName: t("accruals.accrual_codes.table.columns.show_code"),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            type: 'singleSelect',
            valueOptions: [t('general.basic.yes'), t('general.basic.no')],
            valueGetter: (value: boolean | null) => (value ? t('general.basic.yes') : t('general.basic.no')),
            renderCell: (params: any) => (params.row?.show_code ? t('general.basic.yes') : t('general.basic.no')),
        },
    ], [t]);

    const cleanSelected = useCallback(() => {
        setSelected([]);
        setSelectedAccrualCode([]);
    }, []);

    return {
        rows, // filas
        loading, // estado de carga
        loadData, // función para cargar los datos
        selectedAccrualCode, // código de acumulación seleccionado
        setSelectedAccrualCode, // función para establecer el código de acumulación seleccionado
        contextMenu, // estado del menú contextual
        setContextMenu, // función para establecer el estado del menú contextual
        selected, // elementos seleccionados
        setSelected, // función para establecer los elementos seleccionados,
        columns, // definición de columnas para la tabla
        cleanSelected // función para limpiar la selección
    };
}